// extracted by mini-css-extract-plugin
module.exports = {"confetti-canvas":"confetti__confetti-canvas___35Iwr"};